import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    title: String,
      text: String,
      copiedMessage: String
  }

  async share(event) {
    event.preventDefault()
    
    const shareData = {
      title: this.titleValue || document.title,
      text: this.textValue || "",
      url: this.urlValue || window.location.href
    }
    
    // Use Web Share API (works on mobile and desktop when available)
    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (error) {
        // User cancelled or error occurred
        if (error.name !== "AbortError") {
          console.error("Share failed:", error)
          // Fallback to copying URL
          this.fallbackToClipboard(shareData.url)
        }
      }
    } else {
      // Fallback: copy URL to clipboard
      this.fallbackToClipboard(shareData.url)
    }
  }
  
  async fallbackToClipboard(url) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url)
          this.showFeedback(this.copiedMessageValue)
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea")
        textArea.value = url
        textArea.style.position = "fixed"
        textArea.style.left = "-999999px"
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand("copy")
        document.body.removeChild(textArea)
          this.showFeedback(this.copiedMessageValue)
      }
    } catch (error) {
      console.error("Failed to copy URL:", error)
    }
  }
  
  showFeedback(message) {
      // Snapshot innerHTML, not textContent: icon-only triggers (profile header, Découvrir
      // card) hold an <svg> and nothing else, so restoring textContent left them blank.
      if (this.restoreTimeout) return

      const originalHTML = this.element.innerHTML
    this.element.textContent = message || "Copied!"

      this.restoreTimeout = setTimeout(() => {
          this.element.innerHTML = originalHTML
          this.restoreTimeout = null
    }, 2000)
  }

    disconnect() {
        clearTimeout(this.restoreTimeout)
        this.restoreTimeout = null
    }
}

